import { createOidcService } from "./oidc";
import { UsersRepository, AuthorizersRepository } from "../repositories";
import { user, contract } from "../stores/index";
import { navigate } from "svelte-routing";
import { config } from "./index";

const IDP_STORAGE_KEY = "gl_idp";

const services = {
  auth0: createOidcService({
    issuer: config.AUTH0_ISSUER ?? `https://${config.AUTH0_DOMAIN}/`,
    clientId: config.AUTH0_CLIENT_ID,
    redirectUri: config.REDIRECT_URI,
    scope: config.OIDC_SCOPE ?? "openid email profile offline_access",
    audience: config.AUTH0_AUDIENCE,
  }),
  okta: createOidcService({
    issuer: config.OKTA_ISSUER,
    clientId: config.OKTA_CLIENT_ID,
    redirectUri: config.REDIRECT_URI,
    scope: config.OIDC_SCOPE ?? "openid email profile offline_access",
  }),
};

function defaultIDP() {
  return config.OKTA_ISSUER ? "okta" : "auth0";
}

export function getIDP() {
  const saved = localStorage.getItem(IDP_STORAGE_KEY) ?? defaultIDP();
  return services[saved];
}

export async function resolveIDP(email) {
  try {
    const { type } = await AuthorizersRepository.getIdpByEmail(email);
    localStorage.setItem(IDP_STORAGE_KEY, type);
    return services[type];
  } catch (error) {
    console.log("error :", error);
    return config.OKTA_ISSUER ? services.okta : services.auth0;
  }
}

// True while the current URL is the IdP's redirect back into the app — the
// success case (code=) as well as Okta's error redirect (error=). The IDP
// choice itself survives the redirect in localStorage, written by resolveIDP().
export function isLoginCallback() {
  const params = new URLSearchParams(window.location.search);
  return params.has("code") || params.has("error");
}

export async function handleLoginCallback() {
  await getIDP().handleCallback();
}

export async function globalLogin(returnTo) {
  const meResult = await UsersRepository.me();
  console.log("meResult :", meResult);

  let userStore;
  user.subscribe((data) => {
    userStore = data;
  });

  if (meResult.contracts.length === 0 && !meResult.data.isMaster) {
    throw new Error("This user is not assigned to any application");
  } else {
    contract.set(meResult.contracts[0]);

    const contractApps = await UsersRepository.getUserApps(
      meResult.data.id,
      meResult.contracts[0],
    );
    const policies = await UsersRepository.getUserPolicies(meResult.data.id);

    user.set({
      data: meResult.data,
      contracts: meResult.contracts,
      apps: contractApps.list,
      policies: policies.list,
      ...userStore,
    });

    const intendedUrl =
      returnTo || new URLSearchParams(window.location.search).get("returnTo");
    if (intendedUrl) {
      navigate(intendedUrl);
    } else {
      navigate("/");
    }
  }
}
